import socket from "./socketConfig";
import calendarHandler from "./context/calendarHandler";
import userHandler from "./context/userHandler";
import budgetHandler from "./context/budgetHandler";
import companyHandler from "./context/companyHandler";
import { userStore } from "@/store/user";
import notificationHandler from "./context/notificationHandler";

const reconnectInterval = 5000;

function getAuthToken(): string | null {
  const user = localStorage.getItem("user");
  const token = user ? JSON.parse(user).token : null;
  return token !== "null" ? token : null;
}

export default {
  connect(): void {
    const authToken = getAuthToken();
    if (socket.connected || !authToken) return;
    socket.io.opts.transportOptions.polling.extraHeaders.Authorization =
      authToken;

    socket.connect();

    socket.on("connect", () => {
      calendarHandler.setupEventListeners();
      userHandler.setupEventListeners();
      budgetHandler.setupEventListeners();
      companyHandler.setupEventListeners();
      notificationHandler.setupEventListeners();
    });

    socket.on("disconnect", () => {
      calendarHandler.removeEventListeners();
      userHandler.removeEventListeners();
      budgetHandler.removeEventListeners();
      companyHandler.removeEventListeners();
      notificationHandler.removeEventListeners();
      this.reconnect();
    });

    socket.on("unauthorized", () => {
      const user = userStore();
      user.logout();
    });
  },

  disconnect(): void {
    if (!socket.connected) return;
    calendarHandler.removeEventListeners();
    userHandler.removeEventListeners();
    budgetHandler.removeEventListeners();
    companyHandler.removeEventListeners();
    notificationHandler.removeEventListeners();

    socket.disconnect();
  },

  reconnect(): void {
    setTimeout(() => {
      this.connect();
    }, reconnectInterval);
  },
};
